import Vue from 'vue'
import 'es6-promise/auto'
import { createApp } from './app'
import ProgressBar from './components/ProgressBar.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import './assets/scss/main.scss'
import './assets/css/main.css'
import './assets/css/bormar.css'

// Phone Number Input
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Vue select
import 'vue-select/dist/vue-select.css';

// Vue Animate
import VAnimateCss from 'v-animate-css';
Vue.use(VAnimateCss);

// Add quill editor
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
if (process.browser) {
	const VueQuillEditor = require('vue-quill-editor/dist/ssr')
	Vue.use(VueQuillEditor, /* { default global options } */)
}

// You need a specific loader for CSS files
import '../node_modules/vue-datetime/dist/vue-datetime.css'

// global progress bar
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

// Register axios to http
import Axios from 'axios'
Vue.prototype.$http = Axios;
// console.log(localStorage);

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
	beforeRouteUpdate (to, from, next) {
		console.log('Change route from ',from, ' to ', to);
		const { asyncData } = this.$options
		// console.log(this.$options.asyncData);
		if (asyncData) {
			asyncData({
				store: this.$store,
				route: to
			}).then(next).catch(next)
		} else {
			next()
		}
	}
})

const { app, router, store } = createApp()

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
	store.replaceState(window.__INITIAL_STATE__)
}

// wait until router has resolved all async before hooks
// and async components...
router.beforeEach((to, from, next) => {
	console.log('wait async data before change route from ', from.path, ' to ', to.path);
	next()
})

router.onReady(() => {
	// Add router hook for handling asyncData.
	// Doing it after initial route is resolved so that we don't double-fetch
	// the data that we already have. Using router.beforeResolve() so that all
	// async components are resolved.
	// router.beforeEach((to, from, next) => {
	// 	console.log('router patch : ', to, from, next);
	// })

	router.beforeResolve((to, from, next) => {
		console.log('router patch B from ', from.path, ' to ', to.path);
		const matched = router.getMatchedComponents(to)
		const prevMatched = router.getMatchedComponents(from)
		let diffed = false
		const activated = matched.filter((c, i) => {
			return diffed || (diffed = (prevMatched[i] !== c))
		})
		const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _)
		console.log('async hooks... ', asyncDataHooks);
		if (!asyncDataHooks.length) {
			return next()
		}

		bar.start()
		Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
			.then(() => {
				bar.finish()
				next()
			})
			.catch(next)
	})

	// actually mount to DOM
	app.$mount('#app')
})

// service worker
if ('https:' === location.protocol && navigator.serviceWorker) {
	navigator.serviceWorker.register('/service-worker.js')
}



// WEBPACK FOOTER //
// src/entry-client.js